// @flow
import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import { hot } from 'react-hot-loader/root'
import './styles.scss'
import { PartySegment } from 'components/partySegment'
import Masthead from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import ThemeSwitch from '@ta-interaktiv/react-theme-switch'
import { partyData } from '../_data'
import { MDX, Image, Tracking } from 'contentbricks'

// TODO Set the correct article ID here
const ARTICLE_ID = '28437590'
const LOCALE = 'fr'
const LOCALES = require('locales/locales_' + LOCALE + '.yml')
const PARTIES_NAME: string[] = ['UDC', 'PS', 'PLR', 'PES', 'PDC', 'PVL', 'PBD']
const PARTIES: string[] = ['SVP', 'SP', 'FDP', 'GPS', 'CVP', 'GLP', 'BDP']
function AppComponent() {
  console.log(LOCALES)
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      {/* TODO Replace the following segment with your project cover */}
      <header className='ui vertical  fitted  segment'>
        <div className='ui container'>
          <h1 className='ui image header'>
            <div className='content'>
              {LOCALES.title}
              <div className='sub header'>{LOCALES.lead}</div>
            </div>
          </h1>
          <div className="ta author">Gregor Poletti et Sebastian Broschinski</div>
        </div>
      </header>

      {/* TODO And probably remove the following segment and replace it with
       your own content */}
      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <MDX file={require('text/Intro.mdx')} />
        </div>
      </div>
      <div className='ui vertical  relaxed segment'>
        <div className='ui text container'>
          <div className='ui vertical grey relaxed segment mapkey'>
            <div className='text'>
              <b>{LOCALES.key.title}</b>
              <br />
              {LOCALES.key.text}
            </div>
            <Image file="images/KEY.svg" className='keyImage' />
          </div>
        </div>
      </div>
      <div className='ui vertical segment'>
        <div className='ui container'>
          {PARTIES.map((party, i) => {
            console.log(i)
            return (
              <div key={i}>
                {i === 1 && <Tracking label='content25' />}
                {i === 3 && <Tracking label='content50' />}
                {i === 6 && <Tracking label='content75' />}
                <PartySegment
                  key={i}
                  name={PARTIES_NAME[i]}
                  party={party}
                  data={partyData[party]}
                  locales={LOCALES.dashboard}
                />
              </div>
            )
          })}
        </div>
      </div>

      <Footer
        locale='fr'
        mailTo='24heures.web@24heures.ch'
        hidePortfolioTeaser
        questions={[
          'Avez-vous trouvé ce contenu informatif?',
          'La mise en forme vous plaît-elle?'
        ]}
        articleId={ARTICLE_ID}
        credits={LOCALES.credits}
      />
    </div>
  )
}

export default hot(AppComponent)
